export class ScheduleProcess {
    id : string;
    serviceName : string;
    moduleName : string;
    dtInicio : string;
    dtFim : string;
    observacao : string;
    _dataInicioTela: string;
    _dataFimTela: string;

    constructor() {}
}